<script setup>
import { ref, watch, onBeforeUnmount } from 'vue';
const files = defineModel({ type: Array, default: () => [] });
const previews = ref([]);
const invalid = ref(false);
const clear = () =>
  previews.value.forEach(item => URL.revokeObjectURL(item.url));
watch(files, value => {
  clear();
  previews.value = value.map(file => ({
    name: file.name,
    url: URL.createObjectURL(file),
  }));
});
onBeforeUnmount(clear);
const add = event => {
  const next = [...files.value, ...Array.from(event.target.files)];
  invalid.value =
    next.length > 3 ||
    next.some(
      file =>
        !['image/png', 'image/jpeg', 'image/webp'].includes(file.type) ||
        file.size > 5 * 1024 * 1024
    );
  if (!invalid.value) files.value = next;
  event.target.value = '';
};
</script>

<template>
  <div class="space-y-3">
    <label class="block text-sm text-n-slate-11">
      {{ $t('BUG_REPORTS.images') }}
      <input
        type="file"
        accept="image/png,image/jpeg,image/webp"
        multiple
        class="block mt-2 w-full"
        @change="add"
      />
    </label>
    <p v-if="invalid" role="alert" class="text-n-ruby-11">
      {{ $t('BUG_REPORTS.errors.images') }}
    </p>
    <ul class="flex flex-wrap gap-3 list-none p-0 m-0">
      <li v-for="(preview, index) in previews" :key="preview.url" class="w-28">
        <img
          :src="preview.url"
          :alt="preview.name"
          class="w-28 h-20 object-contain rounded"
        />
        <button
          type="button"
          class="text-n-ruby-11 text-sm"
          @click="files = files.filter((_, i) => i !== index)"
        >
          {{ $t('BUG_REPORTS.remove') }}
        </button>
      </li>
    </ul>
  </div>
</template>
